import React, { useContext } from 'react';
import store, { toggleSummary } from '@carvana/purchase-store';
import styled from 'styled-components';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { currency } from '@carvana/purchase-utils';
import { PurchaseHeaderCart } from '@carvana/purchase-icons';

export const CartWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  border-radius: 61px;
  border: 1px solid #d9dde9;
  padding: 8px 12px;
  width: auto;
  font-size: 14px;
  line-height: 16px;
`;

const defaultProps = {
  display: true,
  vehicle: {},
  vehicleTotalPrice: 0
};

const Cart = (props = defaultProps) => {
  const { display, vehicle, vehicleTotalPrice } = props;
  const { trackEvent } = useContext(AnalyticsContext);

  if (!display) return null;

  return (
    <CartWrapper
      onClick={() => {
        trackEvent('pp_clicked_order_summary');
        if (vehicle) store.dispatch(toggleSummary());
      }}
      style={vehicle && { cursor: 'pointer' }}
    >
      <PurchaseHeaderCart />
      {currency(vehicleTotalPrice)}
    </CartWrapper>
  );
};

export default Cart;
